<template>
  <div id="app">
    <Header></Header>
    <router-view />
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";

export default {
  components: { Header, Footer },

  mounted: function() {
    // 页面开始加载时修改font-size
    var html = document.getElementsByTagName("html")[0];
    var oWidth =
      document.body.clientWidth || document.documentElement.clientWidth;
    // 这里的750是指设计图的大小,自己根据实际情况改变
    html.style.fontSize = (oWidth / 750) * 100 + "px";
    console.log("rem:", html.style.fontSize);
  }
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

html,
body {
  width: 100%;
  font-family: "微软雅黑";
  color: #666666;
  background-size: cover;
}

/* 手机屏幕的字体大小 */
@media screen and (max-width: 768px) {
  #app {
    font-size: 0.05rem;
  }
}
/* 笔记本电脑的字体大小 */
@media screen and (min-width: 768px) and (max-width: 1024px) {
  #app {
    font-size: 0.08rem;
  }
}
/* 台式电脑显示器屏幕字体大小 */
@media screen and (min-width: 1024px) {
  #app {
    font-size: 0.08rem;
  }
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin-bottom: 0.15rem;
}

h2 {
  font-size: 0.14rem;
  font-weight: bold;
}

h3 {
  font-size: 0.11rem;
  font-weight: bold;
}

p {
  margin-bottom: 0.1rem;
}

.mr-20 {
  margin-right: 20px;
}

.ml-20 {
  margin-left: 20px;
}
</style>
